<div
  box-layout
  borderRadius="max"
  color="secondary-surface"
  padding="sm"
  paddingVertical="xxs"
  paddingHorizontal="md"
  [style.background-color]="region().colorCode"
>
  <Text role="caption">
    {{ region().code }}
  </Text>
</div>
